// import stand lib
import React, { useState, useContext } from "react";
import MenuProvider from "../framework/MenuProvider";
import Header from "../framework/Header";
import Login from "../pages/Login";
import {
  Route,
  Switch,
  BrowserRouter as Router,
} from "react-router-dom";
import { AppConfiguration } from "../framework/AppConfigProvider";

// import conponents from components folder
import TopNav from "../framework/TopNav";
import navigation from "./Navigation";
import webRootContext from "./webrootcontext/WebRootContext";
import { UserProfile } from "./UserProfileProvider";   /* Need to override UserProfile */

const Layout = (props) => {
  var logoutURL = 	webRootContext + "/Logout";
  	console.log("Layout:", props);
  // Using Context Provider
  // share same context (ShowMenu) for the child and for the parent component.
  const [ShowMenu, setMenu] = useState(false);

  // this is for the header, call open the menu
  const showMenu = () => {
    setMenu(true);

  };

  // this is for the menu, any click will close the menu
  const hideMenu = () => {
    setMenu(false);

  };  

  // custom logout function
  const logout = (e) => {

    window.location.href = logoutURL;
  };
  
  //Retrieve and display user profile info from the context.
  const currentContext = useContext(UserProfile);
  
  const localConfig = useContext(AppConfiguration);
 
 
  const { firstName, lastName } = (currentContext === undefined ? {firstName:'', lastName:''} : currentContext.userProfile) ;

	// console.log("Configuration from Context:", localConfig);  
 
	// Function to allow updating of page title
	function updateTitle(title) { 
    	props.updateApplicationTitle(title);
    }
  
  function updateUserInHeader(user) { 
    	props.updateUserInHeader(user);
    }
  
	/**
	 * giveAccess checks the user roles against allowAccess (from Navigation.js)
	 *            if a user has the role it's displays the page, otherwise displays unauthorized
	 *            ALL allows all users to access page.
	 */  
	function giveAccess(allowAccess, path, authenticated) {
        let allow = false;
	    let isLoggedIn = sessionStorage.getItem("isLoggedIn");

        // Debugging roles/access
//    	console.log("Checking Access for:" + path,
//    			"\n --> ALL?", allowAccess, " is ", allowAccess.includes("ALL"), (allowAccess.includes("ALL") === true),
//    			"\n --> Logged in:", isLoggedIn + 
//    			"\n --> Authenticated:", authenticated + 
//    			"\n -->", currentContext);

		
	    if (allowAccess.includes("ALL") === true) {
        	allow = true;
      	} else if ((isLoggedIn === true) || (authenticated === true)) {
           if (!isLoggedIn) {
             sessionStorage.setItem("isLoggedIn",  authenticated);
           }
      		allow = true;
    	}
    	
    	updateUserInHeader(currentContext.userProfile);
 		return allow;
  	}
  

  return (
    <div>
      <MenuProvider.Provider value={ShowMenu}>
        <Router>
          <Header
            longTitle={localConfig.configProperties.applicationName}
            shortTitle={localConfig.configProperties.applicationNameAbbrev}
            handleMouseUp={showMenu}
            navMap={props.navMap}
            userName={props.userName}
            buttonLabel={"log out"}
            buttonAction={(e) => logout(e)}
          />
          <TopNav
            hideMenu={hideMenu}
            showMenu={showMenu}
            navMap={props.navMap}
            buttonLabel={"log out"}
            buttonAction={(e) => logout(e)}
            userName={firstName + " " + lastName}
            shortTitle={localConfig.configProperties.applicationNameAbbrev}
          />
          <article>
            <div className="container">
              <Switch>
                {navigation.map(({ to, component, allowAccess, needExact, text }, i) => (
                 <Route
		              key={i}
		              path={to}
		              render={(renderProps) => {
                        if(giveAccess(allowAccess, to, currentContext.userProfile.authenticated)) {
                        	const Component = component;
	                        return <Component {...props}  {...renderProps} updateTitle={(e) => updateTitle(e)}  updateUserInHeader={(e) => updateUserInHeader(e)}/>;
                        } else {
        	                return <Login {...props} {...renderProps}  updateTitle={(e) => updateTitle(e)}/>;
                        }
                      
                      }}
		              exact={needExact}
		            />
                ))}

                
              </Switch>
            </div>
          </article>
        </Router>
      </MenuProvider.Provider>
    </div>
  );
};

//function PrivateRoute({component: Component, isAuthenticated, ...rest}) {
//  return (
//    	<Route {...rest} render={(props) => (
//        	isAuthenticated ? <Component {...props} /> : <Redirect to='Login' />
//        	
//      )} />
//  );
//}

export default Layout;